import service from './request'

const url = 'http://rapapi.org/mockjs/33010/'
// const url = 'www.31huiyi.com'
var  webUrl=(typeof(PublicPath)!="undefined" && PublicPath.ScrmDomain) || "https://www.31meijia.com";
// 设置请求
export function setRequest(id) {
    return service.get(url + 'Activities/ActivitiesShare/GetActivitiesSetting?CompanyId=1' + id)
}

// 搜索列表
export function searchList(params) {
    return service.post(url + 'Activities/ActivitiesShare/Search', params)
}

// 视频列表
export function getVideoList(params) {
    return service.post('/Mobiles/ContentVideo/SearchVideo', params)
}

// 图形验证
export function getImage(params) {
    return service.post(webUrl+'/AuthVerification/SendSmsCode', params)
}

// 短信验证
export function getNote(params) {
    return service.post(webUrl+'/AuthVerification/SaveVerify', params)
}
// 密码验证
export function VerificationPassWord(params) {
    return service.post(webUrl+'/AuthVerification/VerificationPassWord', params)
}

// 优惠码领取页面参数获取
export function getGetCodeSetting(companyId,codeSettingId,openId,publicNumId) {
    return service.get(webUrl+'/WeiXin/DiscountCode/GetCodeSetting?companyId=' + companyId+"&codeSettingId="+codeSettingId+"&openId="+openId+"&publicNumId="+publicNumId)
}

// 优惠码领取请求
export function saveReceiveCode(params) {
    return service.post(webUrl+'/WeiXin/DiscountCode/SaveReceiveCode',params)
}
// 我的优惠码列表
export function getDiscountCodeList(params) {
    return service.post(webUrl+'/WeiXin/DiscountCode/getdiscountcode-list',params)
}


// WEBPACK FOOTER //
// ./src/pages/api/server.js